import { StatisticsDashboard } from "../../components/report";

export default function StatisticsDashboardPage() {
  return <StatisticsDashboard />;
}
